import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import cx from 'classnames';

import ArrowSvg from 'app/components/common/Arrow';

import s from './Button.module.sass';

type ButtonProps = {
  type?: 'button' | 'submit' | 'reset' | undefined
  theme?: keyof typeof themeClass
  sizeT?: keyof typeof sizeClass
  sortType?: boolean
  isSorted?: boolean
  className?: string
  href?: string
  to?: string
} & React.HTMLProps<HTMLButtonElement>;

const themeClass = {
  primary: s.primary,
  secondary: s.secondary,
  tertiary: s.tertiary,
  octonary: s.octonary,
  quinary: s.quinary,
  senary: s.senary,
  nonary: s.nonary,
  denary: s.denary,
  clear: s.clear,
  plain: s.plain,
};

const sizeClass = {
  small: s.small,
  medium: s.medium,
  large: s.large,
};

const Button: React.FC<ButtonProps> = ({
  type = 'button',
  theme = 'primary',
  sizeT = 'large',
  isSorted = false,
  sortType,
  children,
  className,
  href,
  to,
  ...props
}) => {
  const compoundClassName = cx(
    s.root,
    themeClass[theme],
    sizeClass[sizeT],
    className,
    { [s.link]: href || to },
  );

  if (href) {
    return (
      <a
        target="_blank"
        rel="noreferrer noopener"
        className={compoundClassName}
        href={href}
        {...(props as React.HTMLProps<HTMLAnchorElement>)}
      >
        {children}
      </a>
    );
  }

  if (to) {
    return (
      <Link {...(props as LinkProps)} to={to} className={compoundClassName}>
        {children}
      </Link>
    );
  }

  return (
    <button
      className={compoundClassName}
      // @ts-ignore
      // eslint-disable-next-line react/button-has-type
      type={type}
      {...(props as React.HTMLProps<HTMLButtonElement>)}
    >
      {children}

      {isSorted && (
      <ArrowSvg
        className={cx(s.arrow)}
        theme={sortType ? 'descending' : 'ascending'}
      />
      )}
    </button>
  );
};

export default Button;
